import { pink } from '@material-ui/core/colors';

export default (theme) => ({
  root: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    marginTop: theme.spacing(3),
    paddingLeft: 0,
    paddingRight: 0,
  }),
  item: {
    paddingTop: 0,
    paddingBottom: 0,
    marginTop: theme.spacing(1),
    paddingLeft: 0,
    paddingRight: 0,
  },
  container: {
    backgroundColor: '#484653',
    backgroundSize: 'cover',
    paddingBottom: '2rem',
    width: '100vw',
    minHeight: '100vh',
  },
  content: {
    margin: 'auto',
    padding: '6rem 0 0',
    width: 500,
    maxWidth: '90vw',
  },
  profileImage: {
    width: '10rem !important',
    height: '10rem !important',
    boxShadow: '0px 6px 6px -3px rgba(0, 0, 0, 0.2), 0px 10px 14px 1px rgba(0, 0, 0, 0.14), 0px 4px 18px 3px rgba(0, 0, 0, 0.12)',
    position: 'absolute !important',
    left: 'calc(50% - 5rem)',
    top: '5rem',
  },
  profileContainer: {
    marginBottom: '1rem',
    padding: '0 1rem',
    '& h2': {
      color: pink.A400,
      textAlign: 'center',
      marginBottom: 0,
    },
    '& h4': { textAlign: 'center' },
  },
  offset: { paddingTop: '6rem' },
  loadingContainer: {
    margin: '1rem auto 0',
    display: 'block',
    width: '3rem',
  },
});
